import type { GoogleRule } from "./types";

/**
 * O que o Google exige além do que o schema.org define. Nada disso sai do
 * vocabulário: são regras de produto do buscador, e mudam sem o vocabulário
 * mudar. Toda afirmação aqui tem que sobreviver ao Rich Results Test — quando
 * divergirem, o validador é a autoridade e esta tabela é que está errada.
 */
export const googleRules: Record<string, GoogleRule> = {
  Product: {
    requiredForNode: ["name"],
    requiredForRichResult: ["name", "image", "offers.price"],
  },

  BlogPosting: {
    requiredForNode: ["headline"],
    recommendedForRichResult: [
      "headline",
      "image",
      "datePublished",
      "dateModified",
      "author.name",
      "author.url",
    ],
    note: "O Google não exige nenhuma propriedade para o resultado de artigo. As marcadas são as que ele recomenda.",
  },
};
